import type { ActionItem } from '@/lib/contract';
import { cn } from '@/lib/cn';

const TONE_CLASS: Record<ActionItem['tone'], string> = {
  neutral: 'text-dim',
  warn: 'text-warn',
  danger: 'text-danger'
};

/** "Needs your action" - each row is a sans title over a mono, tone-colored meta line. */
export function ActionList({ items, className }: { items: ActionItem[]; className?: string }) {
  return (
    <ul className={cn('grid', className)}>
      {items.map((item, index) => (
        <li key={item.id} className={cn('grid gap-1.5 py-3', index > 0 && 'border-t border-border')}>
          <span className="text-[13px] text-foreground">{item.title}</span>
          <span className={cn('font-mono text-[10px] tracking-[0.12em] uppercase', TONE_CLASS[item.tone])}>
            {item.meta}
          </span>
        </li>
      ))}
    </ul>
  );
}
